var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCourseEmptyCover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 239,
    height: 151,
    viewBox: "0 0 239 151",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 239,
    height: 151,
    fill: "#DAEBFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_281_2836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141 31H93C88.6 31 85 34.6 85 39V103C85 107.4 88.6 111 93 111H141C145.4 111 149 107.4 149 103V39C149 34.6 145.4 31 141 31ZM105 39H113V59L109 56L105 59V39ZM141 103H93V39H97V75L109 66L121 75V39H141V103Z",
    fill: "#00479B",
    fillOpacity: 0.48
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_281_2836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(69 23)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourseEmptyCover);
export default __webpack_public_path__ + "static/media/CourseEmptyCover.f5d4cd2bee989e12cbdef9963fc3f55e.svg";
export { ForwardRef as ReactComponent };